// REACT
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";

//CSS
import './Header.css';
import logoImg from "../../images/Logo.png";
import user from "../../images/user.svg"

import Bell from "../../images/Notification/Bell.svg";
import BellToRead from "../../images/Notification/Bell-to-Read.svg";
import Mail from "../../images/Mail.svg";

const Header = ({ userName, openProfile, context, pathname }) => {
    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [hasNotification, setHasNotification] = useState(false);

    const controlHeader = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY > lastScrollY) {
                setShow(false);
            } else {
                setShow(true);
            }
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', controlHeader);
        return () => {
            window.removeEventListener('scroll', controlHeader);
        };
    }, [lastScrollY]);

    useEffect(() => {
        getNotificationStatus();
        async function getNotificationStatus() {
            try {
                const { selectedUserID, idToken } = context;

                const headers = {
                    Authorization: `Bearer ${idToken}`,
                    clientId: selectedUserID,
                };

                const response = await fetch(
                    `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
                    { headers }
                );

                if (!response.ok) {
                    setHasNotification(false);
                    return;
                }

                const data = await response.json();

                // verifica se existe alguma não lida
                const hasUnread = Array.isArray(data)
                    ? data.some((item) => !item.isRead)
                    : false;

                setHasNotification(hasUnread);

            } catch (error) {
                console.error("Error fetching notifications:", error);

                setHasNotification(false);
            }
        }

    }, []);



    return (
        <header className={`header desktop ${show ? 'visible' : 'hidden'}`}>
            <div className='header-container'>
                <div className="header-left">
                    <NavLink
                        to="/">
                        <img src={logoImg} alt="Logo Cliente" className="logo" />
                    </NavLink>
                </div>
                <div className="header-right">
                    <span className="greeting">
                        <strong>Olá</strong>
                        <span className="greeting__name">{userName}</span>
                    </span>
                    <button className="icon-button">
                        {pathname === "/correio" ? (
                            <NavLink
                                to="/">
                                <img src={Mail} />
                            </NavLink>
                        ) : (
                            <NavLink to="/correio">
                                <img src={Mail} />
                            </NavLink>
                        )}
                    </button>
                    <button className="icon-button">
                        {pathname === "/notificacoes" ?
                            (<NavLink
                                to="/">
                                {hasNotification ? (<img src={BellToRead} />) : (<img src={Bell} />)}

                            </NavLink>) :
                            (<NavLink
                                to="/notificacoes">
                                {hasNotification ? (<img src={BellToRead} />) : (<img src={Bell} />)}
                            </NavLink>)}
                    </button>
                    <img src={user} alt="Avatar" className="avatar" onClick={() => {
                        openProfile();
                    }} />
                </div>
            </div>

        </header >
    );
};

export default Header;